function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Web Component: iamCartSummary <iam-cart-summary>
// Extends: HTMLElement
// ----------------------------------------------------------------------------
// TODO
// ----------------------------------------------------------------------------
// Customization:
// - TODO
// ----------------------------------------------------------------------------
// Event Listeners:
// - `cart:modified`       → Listens for when the cart is modified
// ----------------------------------------------------------------------------
// Event Triggers:
// - `cartForm:summary:updated`    → Triggers when the cart summary is updated
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Fetches cart summary data and updates the cart summary section
// ----------------------------------------------------------------------------
// Gotchas:
// - Relies on promises to fetch cart summary data, which may fail if the API calls do not resolve successfully.
// - Error messages are injected into the `.summary__errors-container` element
//   and the summary is marked with a `--error` class until resolved
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamFormElement from 'scripts/classes/iamFormElement';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { sectionRendering } from 'scripts/helpers/iamota-shopify-ajax';
import translate from 'scripts/helpers/iamota-translate';

// Elements
import '../checkout-button/checkout-button';
//import 'snippets/free-shipping-progress/free-shipping-progress';

// Styles
import './_cart-summary.scss';

// -------------------------------------
// Web Component
// -------------------------------------

class iamCartSummary extends iamFormElement {
  get namespace() {
    return "".concat(this.formName, ":summary");
  }

  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Variables
    this.cartSummaryContainer = this.querySelector('.cart-summary__content');

    // Bind Event Listeners
    iamotaEventHandler.subscribe('cart:modified', this.onCartModified.bind(this), {
      source: "cart-summary.js"
    });

    // Validation
    if (!this.validateRequiredAttributes(['cartSummaryContainer'])) return;
  }
  onCartModified() {
    var _this = this;
    this.setLoading(true);
    sectionRendering.fetchSingle('cart-summary__content').then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (sectionContent) {
        var cartSummaryHTML = yield iamotaEventHandler.applyFilters('cartForm:summary:updating', sectionContent);
        _this.cartSummaryContainer.innerHTML = cartSummaryHTML;
        iamotaEventHandler.trigger('cartForm:summary:updated', {
          cartSummaryHTML
        }, {
          context: _this
        });
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(error => {
      console.error('cartForm: Error fetching main-cart-summary__content section:', error);
      this.cartSummaryContainer.innerHTML = translate('An unexpected error occurred when updating the cart summary. Please try reloading the page.', 'cartForm.error_retrieving_cart_summary');
    }).finally(() => {
      this.setLoading(false);
    });
  }
}
customElements.define('iam-cart-summary', iamCartSummary);